import { getRoute } from 'Config';
import { MATCH_ID_REGEX, USER_ID_REGEX, UUID_REGEX } from 'Lib/constants/ids';

/**
 * Removes /app from path
 * @param {String} path
 * @return {String} path
 */
function getRoutePrefixPath() {
  return `${getRoute('prefix')}/`;
}

export function cleanPath(path: string) {
  if (!path) {
    return path;
  }
  const prefix = getRoutePrefixPath();
  const pos = path.indexOf(prefix);
  if (pos >= 0) {
    return path.substring(pos + (prefix.length - 1));
  }
  return path;
}

/* [TODO] Eventually we can look into decoupling routing logic from child components.
 * Several places in the app parse the URL to figure out the current route.
 * The parsing works by converting the url string into an array by splitting on the '/'
 * The first and second index in the array determine the primary and secondary parts of the
 * route. For example /profile/settings profile is primary and settings is secondary.
 * Due to the /app prefix, we need to offset the indexes by adding 1 if the /app prefix is present
 * getPrimaryIndex and getSecondaryIndex check for the app prefix and increment the index accordingly.
 */

export function getPrimaryIndex(pathname: string) {
  let index = 1;
  if (pathname.includes(getRoutePrefixPath())) {
    index += 1;
  }
  return index;
}

export function getSecondaryIndex(pathname: string) {
  let index = 2;
  if (pathname.includes(getRoutePrefixPath())) {
    index += 1;
  }
  return index;
}

/**
 * Parses out the url's pathname without the id
 * @param  {String} url the URL as a string
 * @return the pathname of the url without any ids
 */
export function getUrlPathName(url: string) {
  let pathname = '';
  try {
    pathname = url && new URL(url).pathname;
  } catch (e) {
    return undefined;
  }
  return pathname && stripID(pathname);
}

function isID(segment: string) {
  const isId =
    MATCH_ID_REGEX.test(segment) || USER_ID_REGEX.test(segment) || UUID_REGEX.test(segment);
  const hasCatalog = segment.startsWith('cl_'); // explore catalog prefix
  const result = isId || hasCatalog;
  return result;
}

export function stripID(pathname: string = '') {
  let segments = pathname.split('/');
  segments = segments.map((segment) => {
    if (segment.includes('@')) return '@:username';
    if (isID(segment)) return ':id';
    return segment;
  });
  return segments.join('/');
}
